import lottie from 'lottie-web'
import { deepMerge } from 'js/utils/Utils'

import Common from 'js/_core/Common'

const defaults = {
  instanceName: 'LottieAnimation',
  animationOption: {
    renderer: 'svg', // 描画形式を指定します. // svg or canvas or html svg以外ちゃんとためしてないですが
    loop: true, // trueにしたらループです。1回再生の場合はfalseで
    autoplay: false, // 自動再生です。falseの場合は自分のタイミングで
  },
  animationData: null,
  filePath: '/asset/json/xxx.json',
  durationRatio: 1,
  $name: {
    target: 'data-animation-icon',
  },
  dataName: {
    src: 'animationIcon',
    srcMobile: 'animationIconMobile',
  },
}

export default class LottieAnimation {
  constructor(options) {
    this.$contentRoot = document
    this.$target = null
    this.infoList = []
    deepMerge(this, defaults, options)
  }

  init() {
    this._setInfo()
  }

  destroy() {
    this.stop()
    if (this.infoList && this.infoList.animationObj) {
      this.infoList.animationObj.destroy()
    }
  }

  _setInfo() {
    if (this.$target) {
      let filePath = this.$target.dataset[this.dataName.src] || this.filePath

      if (Common.detection.isMobileLayout) {
        filePath = this.$target.dataset[this.dataName.srcMobile] || filePath
      }

      if (this.animationData) {
        const option = Object.assign(
          {
            container: this.$target,
            animationData: this.animationData,
          },
          this.animationOption
        )

        this.infoList = {
          $target: this.$target,
          animationObj: lottie.loadAnimation(option),
        }
      } else {
        const option = deepMerge(
          {
            container: this.$target,
            path: filePath,
          },
          this.animationOption
        )

        this.infoList = {
          $target: this.$target,
          animationObj: lottie.loadAnimation(option),
        }
      }
    }
  }

  _clearInfo() {}

  async enterAnimation() {
    const animationObj = this.infoList.animationObj
    if (animationObj) {
      animationObj.pause()
      animationObj.setDirection(0)
      await animationObj.play()
    }
  }

  async leaveAnimation(i) {
    const animationObj = this.infoList.animationObj
    if (animationObj) {
      animationObj.pause()
      animationObj.setDirection(-1)
      animationObj.play()
    }
  }

  stop() {
    const animationObj = this.infoList.animationObj
    if (animationObj) {
      animationObj.pause()
    }
  }

  to(value) {
    const animationObj = this.infoList.animationObj
    if (animationObj) {
      animationObj.goToAndStop(value, true)
    }
  }
}